import { TrendingUp, TrendingDown, ArrowRight, CheckCircle, AlertTriangle, XCircle } from 'lucide-react'
import type { TrendIcon } from './types'

interface TrendBadgeProps {
  label: string
  icon: TrendIcon
  explanation?: string | null
}

const iconConfig: Record<TrendIcon, { Icon: typeof TrendingUp; bg: string; text: string; border: string }> = {
  'trending-up': {
    Icon: TrendingUp,
    bg: 'bg-emerald-50 dark:bg-emerald-950/40',
    text: 'text-emerald-700 dark:text-emerald-400',
    border: 'border-emerald-200 dark:border-emerald-800/50',
  },
  'trending-down': {
    Icon: TrendingDown,
    bg: 'bg-amber-50 dark:bg-amber-950/40',
    text: 'text-amber-700 dark:text-amber-400',
    border: 'border-amber-200 dark:border-amber-800/50',
  },
  'arrow-right': {
    Icon: ArrowRight,
    bg: 'bg-stone-100 dark:bg-stone-800/50',
    text: 'text-stone-600 dark:text-stone-400',
    border: 'border-stone-200 dark:border-stone-700',
  },
  'check-circle': {
    Icon: CheckCircle,
    bg: 'bg-emerald-50 dark:bg-emerald-950/40',
    text: 'text-emerald-700 dark:text-emerald-400',
    border: 'border-emerald-200 dark:border-emerald-800/50',
  },
  'alert-triangle': {
    Icon: AlertTriangle,
    bg: 'bg-amber-50 dark:bg-amber-950/40',
    text: 'text-amber-700 dark:text-amber-400',
    border: 'border-amber-200 dark:border-amber-800/50',
  },
  'x-circle': {
    Icon: XCircle,
    bg: 'bg-amber-50 dark:bg-amber-950/40',
    text: 'text-amber-700 dark:text-amber-400',
    border: 'border-amber-200 dark:border-amber-800/50',
  },
}

export function TrendBadge({ label, icon, explanation }: TrendBadgeProps) {
  const { Icon, bg, text, border } = iconConfig[icon]

  return (
    <div className={`inline-flex items-start gap-3 px-4 py-3 rounded-md border ${bg} ${border}`}>
      <Icon className={`w-3.5 h-3.5 flex-shrink-0 mt-0.5 ${text}`} />
      <span className={`text-xs flex-1 leading-relaxed ${text}`}>
        <span className="font-semibold">{label}</span>
        {explanation && <span className="font-normal"> · {explanation}</span>}
      </span>
    </div>
  )
}
